module.exports = __webpack_public_path__ + "media/images/sample/product-11-5fec4d0e1a475c4201ef902cabc99061.png";